import React from "react";

const IconCounts = (props) => {
  return (
    <React.Fragment>
      <div onClick={props.onClick} className={`${props.type} icon-counts`}>
        <div className="custom-icons" />
        {props.text ? (
          <p
            className="com-text"
            style={{ cursor: props.disabled ? "default" : "pointer" }}
          >
            {" "}
            &nbsp; {props.text}{" "}
            {props.count !== undefined && `(${props.count})`}{" "}
          </p>
        ) : (
          <div className="bullet truncate"> &nbsp; {"• " + props.count} </div>
        )}
      </div>
      <style jsx="true">
        {`
          .icon-counts {
            display: flex;
            align-items: center;
            font-size: 12px;
            cursor: ${props.text && !props.disabled ? "pointer" : "default"};
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default IconCounts;
